define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/has",
	"csi/def/Request",
	"csi/heading/AttributeAction",
	"csi/xml"
], function(declare,lang,has,Request,AttributeAction,xml) {

	return declare(AttributeAction, {
		constructor: function(def) {
			this.m_id = "RefreshThumbnail";
			this.m_right = xml.RIGHT_WRITE;
			this.m_request = lang.mixin(new Request(),{
				m_module: "SiteAdmin",
				m_operation: "RefreshThumbnail"
			});
			this.classController = "csi.heading.RefreshThumbnailController";
		},

		hasAccess: function(/*csi.def.Context*/ctx) {
			// summary: to support RefImage renderer, need to change context to image node before checking for access rights
			var	image = this._getImageUrl(ctx);
			
			if (!xml.isValidURL(image) || has("csi-no-files")) {
				return false;
			}

			ctx.pushParams().setNodeURL(image);
			var	res = this.inherited(arguments);
			ctx.pop();
			return res;
		},

		checkNodeAccess: function(/*Node*/node) {
			// summary: avoid AttributeAction::checkNodeAccess to check for attribute access
			return AttributeAction.superclass.checkNodeAccess.call(this, node);
		},

		_getImageUrl: function(/*csi.def.Context*/ctx) {
			// summary: handles refmap to Image nodes and url attributes on Image to Thumbnail/Viewable
			var	url = this._getValue(ctx);
			if (ctx.cache.getNode(url)) {
				return url;
			}

			var	node = ctx.getNode();
			if (node && (node.$Type == "Image")) {
				return node.$URL;
			}

			return null;
		}
	});
});